/* ON ME FOREVER — ficha de producto (om-pdp-corset).
   JS progresivo, sin dependencias. Shopify sigue siendo la fuente de verdad:
   precio, disponibilidad y checkout salen de los datos del producto y del carrito. */
(function () {
  'use strict';

  function formatMoney(cents, format) {
    var value = (cents / 100);
    var noDec = Math.round(value).toLocaleString('es-CO');
    var twoDec = value.toLocaleString('es-CO', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return (format || '${{amount_no_decimals}}').replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      if (k === 'amount_no_decimals' || k === 'amount_no_decimals_with_comma_separator') return noDec;
      if (k === 'amount_with_comma_separator' || k === 'amount_with_period_and_space_separator') return twoDec;
      if (k === 'amount') return value.toLocaleString('en-US', { minimumFractionDigits: 2 });
      return noDec;
    });
  }

  function OmPdp(root) {
    this.root = root;
    this.variants = JSON.parse(root.querySelector('[data-om-variants]').textContent);
    this.form = root.querySelector('[data-om-form]') || root.querySelector('form');
    this.input = root.querySelector('[data-om-variant-input]');
    this.fieldsets = Array.prototype.slice.call(root.querySelectorAll('[data-om-option]'));
    this.sizeIndex = parseInt(root.dataset.sizeIndex, 10);
    this.moneyFormat = root.dataset.moneyFormat;
    this.buyBtn = root.querySelector('[data-om-buy-now]');
    this.buyLabel = root.querySelector('[data-om-buy-label]');
    this.addBtn = root.querySelector('[data-om-add]');
    this.stock = root.querySelector('[data-om-stock]');
    this.error = root.querySelector('[data-om-error]');
    this.sticky = root.querySelector('[data-om-sticky]');
    this.buyNowText = this.buyLabel ? this.buyLabel.textContent.trim() : 'Comprar ahora';
    this.bind();
    this.update(false);
    this.initGallery();
    this.initDialogs();
    this.initSticky();
    this.initEta();
    this.initThumbs();
    this.initLook();
  }

  OmPdp.prototype.selected = function () {
    return this.fieldsets.map(function (fs) {
      var c = fs.querySelector('input:checked');
      return c ? c.value : null;
    });
  };

  OmPdp.prototype.findVariant = function (sel) {
    if (!this.fieldsets.length) return this.variants[0];
    if (sel.indexOf(null) !== -1) return null;
    for (var i = 0; i < this.variants.length; i++) {
      var v = this.variants[i], ok = true;
      for (var j = 0; j < sel.length; j++) if (v.options[j] !== sel[j]) { ok = false; break; }
      if (ok) return v;
    }
    return null;
  };

  /* Marca valores sin stock según lo demás elegido (se pueden ver, nunca agregar) */
  OmPdp.prototype.markAvailability = function (sel) {
    var self = this;
    this.fieldsets.forEach(function (fs, idx) {
      fs.querySelectorAll('input[data-om-value]').forEach(function (inp) {
        var any = self.variants.some(function (v) {
          if (v.options[idx] !== inp.value || !v.available) return false;
          for (var j = 0; j < sel.length; j++) {
            if (j === idx || sel[j] === null) continue;
            if (v.options[j] !== sel[j]) return false;
          }
          return true;
        });
        var label = fs.querySelector('label[for="' + inp.id + '"]');
        if (label) {
          label.classList.toggle('is-soldout', !any);
          var sr = label.querySelector('.om-visually-hidden');
          if (!any && !sr) { sr = document.createElement('span'); sr.className = 'om-visually-hidden'; sr.textContent = ' (agotado)'; label.appendChild(sr); }
          if (any && sr) sr.remove();
        }
      });
    });
  };

  OmPdp.prototype.update = function (fromUser) {
    var sel = this.selected();
    var v = this.findVariant(sel);
    this.current = v;
    this.markAvailability(sel);

    this.fieldsets.forEach(function (fs, idx) {
      var l = fs.querySelector('[data-om-opt-label]');
      if (l) l.textContent = sel[idx] || 'elige una';
    });

    var missingSize = this.sizeIndex > -1 && sel[this.sizeIndex] === null;
    this.state = !v ? (missingSize || sel.indexOf(null) !== -1 ? 'choose' : 'unavailable') : (v.available ? 'ok' : 'soldout');
    if (!this.variants.some(function (x) { return x.available; })) this.state = 'soldout';
    this.input.value = v && v.available ? v.id : '';

    var label = { ok: this.buyNowText, choose: 'Elige tu talla', soldout: 'Agotado', unavailable: 'No disponible' }[this.state];
    if (this.buyLabel) this.buyLabel.textContent = label;
    var blocked = this.state === 'soldout' || this.state === 'unavailable';
    [this.buyBtn, this.addBtn].forEach(function (b) {
      if (!b) return;
      b.setAttribute('aria-disabled', blocked ? 'true' : 'false');
      b.disabled = blocked;
    });

    if (this.stock) {
      var limite = parseInt(this.root.dataset.lowStock || '0', 10);
      var pocas = this.state === 'ok' && v && v.qty !== null && v.qty !== undefined && limite > 0 && v.qty > 0 && v.qty <= limite;
      this.stock.textContent = pocas ? (v.qty === 1 ? '¡Última unidad en esta talla!' : '¡Últimas ' + v.qty + ' unidades en esta talla!') : this.state === 'ok' ? 'Disponible' : this.state === 'soldout' ? 'Esta combinación está agotada. Prueba otra talla o color.' : this.state === 'unavailable' ? 'Esta combinación no existe.' : '';
      this.stock.dataset.state = pocas ? 'low' : this.state;
    }
    if (this.error && fromUser) this.error.hidden = true;

    if (v) {
      var price = this.root.querySelector('[data-om-price]');
      var compare = this.root.querySelector('[data-om-compare]');
      if (price) price.textContent = formatMoney(v.price, this.moneyFormat);
      if (compare) {
        compare.hidden = !(v.compare > v.price);
        if (v.compare > v.price) compare.textContent = formatMoney(v.compare, this.moneyFormat);
      }
      var ship = this.root.querySelector('[data-om-ship]');
      var total = this.root.querySelector('[data-om-total]');
      if (ship && total) total.textContent = formatMoney(v.price + parseInt(ship.dataset.omShip, 10), this.moneyFormat);
      var sp = this.root.querySelector('[data-om-sticky-price]');
      if (sp) sp.textContent = formatMoney(v.price, this.moneyFormat);
      /* No se cambia la URL al elegir talla: el Pixel de Meta lo cuenta como un PageView extra sin deduplicar */
      if (fromUser && v.media) this.showMedia(v.media);
    } else if (fromUser) {
      /* al elegir solo color, mostrar su foto */
      var self = this;
      var partial = this.variants.filter(function (x) {
        return sel.every(function (s, j) { return s === null || x.options[j] === s; }) && x.media;
      })[0];
      if (partial) self.showMedia(partial.media);
    }
    this.updateWhatsapp(v, sel);
    if (this.renderEta) this.renderEta();
  };

  OmPdp.prototype.updateWhatsapp = function (v, sel) {
    var num = this.root.dataset.waNumber;
    if (!num) return;
    var msg = (this.root.dataset.waMessage || '')
      .replace('{producto}', this.root.dataset.productTitle)
      .replace('{variante}', v ? '(' + v.title + ')' : sel.filter(Boolean).length ? '(' + sel.filter(Boolean).join(' / ') + ')' : '');
    msg += '\n' + window.location.origin + this.root.dataset.productUrl + (v ? '?variant=' + v.id : '');
    this.root.querySelectorAll('[data-om-wa]').forEach(function (a) {
      a.href = 'https://wa.me/' + num + '?text=' + encodeURIComponent(msg.trim());
    });
  };

  OmPdp.prototype.requireChoice = function () {
    var fs = this.fieldsets[this.sizeIndex > -1 && this.selected()[this.sizeIndex] === null ? this.sizeIndex : this.selected().indexOf(null)];
    if (this.error) {
      this.error.textContent = this.sizeIndex > -1 ? 'Elige tu talla para continuar.' : 'Elige una opción para continuar.';
      this.error.hidden = false;
    }
    if (fs) {
      fs.classList.add('is-required');
      fs.scrollIntoView({ behavior: 'smooth', block: 'center' });
      var first = fs.querySelector('input:not(:checked)');
      if (first) setTimeout(function () { first.focus({ preventScroll: true }); }, 350);
    }
  };

  OmPdp.prototype.addToCart = function (buyNow) {
    var self = this;
    if (this.state === 'choose') return this.requireChoice();
    if (this.state !== 'ok' || !this.current) return;
    var btn = buyNow ? this.buyBtn : this.addBtn;
    btn.classList.add('is-loading');
    btn.setAttribute('aria-busy', 'true');
    var drawer = document.querySelector('ajax-cart');
    var body = { items: [{ id: this.current.id, quantity: 1 }] };
    if (!buyNow && drawer) { body.sections = 'ajax-cart,ajax-cart-icon'; body.sections_url = window.location.pathname; }
    fetch((window.routes && window.routes.increase_cart_url ? window.routes.increase_cart_url : '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, data: j }; }); })
      .then(function (res) {
        if (!res.ok || res.data.status) {
          var msg = res.data.description || res.data.message || 'No pudimos agregar el producto. Intenta de nuevo.';
          if (/sold out|agotado|already|ya no|quantity/i.test(msg)) msg = 'No hay más unidades disponibles de esta talla y color.';
          throw new Error(msg);
        }
        if (buyNow) { window.location.href = '/checkout'; return; }
        if (drawer && res.data.sections && typeof drawer.renderContents === 'function') {
          drawer.renderContents(res.data);
        } else {
          window.location.href = (window.routes && window.routes.cart_url) || '/cart';
        }
      })
      .catch(function (e) {
        if (self.error) { self.error.textContent = e.message; self.error.hidden = false; }
      })
      .finally(function () {
        btn.classList.remove('is-loading');
        btn.removeAttribute('aria-busy');
      });
  };

  OmPdp.prototype.bind = function () {
    var self = this;
    this.root.addEventListener('change', function (e) {
      if (e.target.matches('[data-om-value]')) {
        var fs = e.target.closest('[data-om-option]');
        if (fs) fs.classList.remove('is-required');
        self.update(true);
      }
    });
    if (this.form) this.form.addEventListener('submit', function (e) { e.preventDefault(); self.addToCart(true); });
    if (this.addBtn) this.addBtn.addEventListener('click', function () { self.addToCart(false); });
  };

  /* Galería: contador en móvil y salto a la foto de la variante */
  OmPdp.prototype.initGallery = function () {
    var list = this.root.querySelector('[data-om-media-list]');
    var counter = this.root.querySelector('[data-om-counter]');
    this.mediaList = list;
    if (!list || !counter || !('IntersectionObserver' in window)) return;
    var items = Array.prototype.slice.call(list.children);
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting && en.intersectionRatio > 0.6) counter.textContent = items.indexOf(en.target) + 1;
      });
    }, { root: list, threshold: [0.6] });
    items.forEach(function (it) { io.observe(it); });
    list.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
      list.scrollBy({ left: (e.key === 'ArrowRight' ? 1 : -1) * list.clientWidth, behavior: 'smooth' });
    });
  };

  OmPdp.prototype.showMedia = function (mediaId) {
    var el = this.mediaList && this.mediaList.querySelector('[data-media-id="' + mediaId + '"]');
    if (!el) return;
    var mobile = window.matchMedia('(max-width: 989px)').matches;
    if (mobile) {
      var L = this.mediaList, pl = parseFloat(getComputedStyle(L).paddingLeft) || 0;
      L.scrollTo({ left: el.getBoundingClientRect().left - L.getBoundingClientRect().left + L.scrollLeft - pl, behavior: 'smooth' });
    } else {
      var first = this.mediaList.firstElementChild;
      if (first !== el) this.mediaList.insertBefore(el, first);
    }
  };

  /* Modal nativo <dialog>: Escape, foco, bloqueo de scroll y clic fuera */
  OmPdp.prototype.initDialogs = function () {
    var self = this;
    this.root.querySelectorAll('[data-om-open]').forEach(function (btn) {
      var dlg = document.getElementById(btn.dataset.omOpen);
      if (!dlg || typeof dlg.showModal !== 'function') return;
      btn.addEventListener('click', function () {
        dlg.showModal();
        document.documentElement.classList.add('om-lock');
        var c = dlg.querySelector('[data-om-close]');
        if (c) c.focus();
      });
      dlg.addEventListener('close', function () {
        document.documentElement.classList.remove('om-lock');
        btn.focus();
      });
      dlg.addEventListener('click', function (e) { if (e.target === dlg) dlg.close(); });
      dlg.querySelectorAll('[data-om-close]').forEach(function (c) { c.addEventListener('click', function () { dlg.close(); }); });
    });
  };

  /* Barra fija en celular: aparece cuando los botones salen de pantalla y nunca tapa contenido */
  OmPdp.prototype.initSticky = function () {
    var self = this, bar = this.sticky, actions = this.root.querySelector('[data-om-actions]');
    if (!bar || !actions || !('IntersectionObserver' in window)) return;
    var mq = window.matchMedia('(max-width: 989px)');
    var io = new IntersectionObserver(function (entries) {
      var show = mq.matches && !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0;
      bar.hidden = !show;
      document.body.classList.toggle('om-has-sticky', show);
    });
    io.observe(actions);
    bar.querySelector('[data-om-sticky-btn]').addEventListener('click', function () {
      if (self.state === 'ok') return self.addToCart(true);
      if (self.state === 'choose') return self.requireChoice();
      actions.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  };

  /* Fecha estimada de entrega en días hábiles (sin contadores ni urgencia artificial) */
  OmPdp.prototype.initEta = function () {
    var box = this.root.querySelector('[data-om-eta]');
    if (!box) return;
    var sel = box.querySelector('[data-om-eta-select]'), out = box.querySelector('[data-om-eta-text]');
    var zonas = (box.dataset.zonas || '').split(/\r?\n|\\n/).map(function (l) {
      var p = l.split('|'); return p.length >= 3 ? { n: p[0].trim(), a: parseInt(p[1], 10), b: parseInt(p[2], 10), c: p[3] ? parseInt(p[3], 10) : null } : null;
    }).filter(Boolean);
    if (!zonas.length) { box.hidden = true; return; }
    zonas.forEach(function (z, i) { var o = document.createElement('option'); o.value = i; o.textContent = z.n; sel.appendChild(o); });
    try { var saved = localStorage.getItem('om-eta-zona'); if (saved && zonas[saved]) sel.value = saved; } catch (e) {}
    function addBusiness(d, n) {
      var r = new Date(d);
      while (n > 0) { r.setDate(r.getDate() + 1); var w = r.getDay(); if (w !== 0 && w !== 6) n--; }
      return r;
    }
    var fmt = { weekday: 'short', day: 'numeric', month: 'short' };
    var self = this;
    this.renderEta = render;
    function render() {
      var z = zonas[sel.value] || zonas[0], now = new Date();
      var a = addBusiness(now, z.a), b = addBusiness(now, z.b);
      var txt = '';
      if (z.c !== null && !isNaN(z.c)) {
        var v = self.current || self.variants[0];
        txt += 'Envío ' + formatMoney(z.c * 100, self.moneyFormat) + ' · Total ' + formatMoney(v.price + z.c * 100, self.moneyFormat) + '. ';
      }
      txt += 'Si compras hoy, te llega entre el ' + a.toLocaleDateString('es-CO', fmt) + ' y el ' + b.toLocaleDateString('es-CO', fmt) + ' (días hábiles; puede variar en festivos).';
      out.textContent = txt;
      try { localStorage.setItem('om-eta-zona', sel.value); } catch (e) {}
    }
    sel.addEventListener('change', render);
    render();
  };

  /* Miniaturas bajo la galería (celular): tocar = ir a esa foto */
  OmPdp.prototype.initThumbs = function () {
    var self = this, box = this.root.querySelector('[data-om-thumbs]');
    if (!box || !this.mediaList) return;
    var list = box.querySelector('.om-thumbs__list');
    var btns = Array.prototype.slice.call(box.querySelectorAll('[data-om-thumb]'));
    function marcar(id) {
      btns.forEach(function (b) { b.classList.toggle('is-active', b.dataset.omThumb === String(id)); });
    }
    btns.forEach(function (b) {
      b.addEventListener('click', function () { self.showMedia(b.dataset.omThumb); marcar(b.dataset.omThumb); });
    });
    box.querySelector('[data-om-thumb-prev]').addEventListener('click', function () { list.scrollBy({ left: -170, behavior: 'smooth' }); });
    box.querySelector('[data-om-thumb-next]').addEventListener('click', function () { list.scrollBy({ left: 170, behavior: 'smooth' }); });
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting && e.intersectionRatio > 0.6) marcar(e.target.dataset.mediaId); });
      }, { root: this.mediaList, threshold: [0.6] });
      Array.prototype.forEach.call(this.mediaList.children, function (li) { io.observe(li); });
    }
  };

  /* Completa tu look: recomendaciones de Shopify (complementarios; si no hay, relacionados). Solo productos disponibles. */
  OmPdp.prototype.initLook = function () {
    var self = this, box = this.root.querySelector('[data-om-look]');
    if (!box || !window.fetch) return;
    var id = box.dataset.productId, track = box.querySelector('[data-om-look-track]'), dots = box.querySelector('[data-om-look-dots]');
    function pedir(intent) {
      return fetch('/recommendations/products.json?product_id=' + id + '&limit=6&intent=' + intent)
        .then(function (r) { return r.ok ? r.json() : { products: [] }; })
        .then(function (j) { return (j.products || []).filter(function (p) { return p.available; }); });
    }
    pedir('complementary').then(function (ps) { return ps.length ? ps : pedir('related'); }).then(function (ps) {
      ps = ps.slice(0, 6);
      if (!ps.length) return;
      ps.forEach(function (p) {
        var src = p.featured_image || '';
        if (src) src += (src.indexOf('?') > -1 ? '&' : '?') + 'width=400';
        var li = document.createElement('li');
        li.className = 'om-look__item';
        var a = document.createElement('a'); a.href = p.url;
        var box2 = document.createElement('span'); box2.className = 'om-look__img';
        if (src) { var im = document.createElement('img'); im.src = src; im.alt = ''; im.loading = 'lazy'; im.width = 300; im.height = 375; box2.appendChild(im); }
        var n = document.createElement('span'); n.className = 'om-look__name'; n.textContent = p.title;
        var pr = document.createElement('span'); pr.className = 'om-look__price'; pr.textContent = formatMoney(p.price, self.moneyFormat);
        a.appendChild(box2); a.appendChild(n); a.appendChild(pr); li.appendChild(a); track.appendChild(li);
      });
      var nd = Math.ceil(ps.length / 2);
      for (var i = 0; i < nd; i++) { var d = document.createElement('span'); if (!i) d.className = 'is-on'; dots.appendChild(d); }
      track.addEventListener('scroll', function () {
        var k = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
        Array.prototype.forEach.call(dots.children, function (d, j) { d.classList.toggle('is-on', j === k); });
      }, { passive: true });
      box.hidden = false;
    }).catch(function () {});
  };

  function init() {
    document.querySelectorAll('[data-om-pdp]').forEach(function (el) {
      if (!el.__omPdp) el.__omPdp = new OmPdp(el);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();

/* ON ME · visor de fotos a pantalla completa (ficha de producto).
   Independiente de la compra: solo lee la galería y abre un <dialog> nativo
   (Escape cierra, el fondo queda inerte y sin scroll, el foco vuelve a donde estaba). */
(function () {
  'use strict';
  var hoverMq = window.matchMedia('(hover: hover) and (pointer: fine)');
  var mobileMq = window.matchMedia('(max-width: 989px)');

  function initZoom(dlg) {
    if (dlg.__omZoom || typeof dlg.showModal !== 'function') return;
    dlg.__omZoom = true;
    var root = dlg.closest('[data-om-pdp]');
    if (!root) return;
    var track = dlg.querySelector('[data-om-zoom-track]');
    var slides = Array.prototype.slice.call(track.children);
    var now = dlg.querySelector('[data-om-zoom-now]');
    var prev = dlg.querySelector('[data-om-zoom-prev]');
    var next = dlg.querySelector('[data-om-zoom-next]');
    var list = root.querySelector('[data-om-media-list]');
    var trigger = null;
    var index = 0;
    var ticking = false;

    function width() { return track.clientWidth || window.innerWidth; }
    function setIndex(i) {
      index = Math.max(0, Math.min(slides.length - 1, i));
      if (now) now.textContent = index + 1;
      if (prev) prev.disabled = index === 0;
      if (next) next.disabled = index === slides.length - 1;
    }
    function go(i, smooth) {
      i = Math.max(0, Math.min(slides.length - 1, i));
      unzoom();
      track.scrollTo({ left: i * width(), behavior: smooth ? 'smooth' : 'auto' });
      setIndex(i);
    }
    function unzoom() {
      slides.forEach(function (s) { s.classList.remove('is-zoomed'); var im = s.querySelector('img'); if (im) im.style.transformOrigin = ''; });
    }
    function indexOfMedia(id) {
      for (var k = 0; k < slides.length; k++) if (slides[k].dataset.mediaId === String(id)) return k;
      return 0;
    }
    function open(i, from) {
      trigger = from || document.activeElement;
      /* las fotos del visor cargan al abrir, no antes */
      slides.forEach(function (s) { var im = s.querySelector('img'); if (im) im.loading = 'eager'; });
      dlg.showModal();
      document.documentElement.classList.add('om-zoom-lock');
      requestAnimationFrame(function () { go(i, false); });
      var x = dlg.querySelector('[data-om-zoom-close]');
      if (x) x.focus({ preventScroll: true });
    }

    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        ticking = false;
        var i = Math.round(track.scrollLeft / width());
        if (i !== index) { unzoom(); setIndex(i); }
      });
    }, { passive: true });
    if (prev) prev.addEventListener('click', function () { go(index - 1, true); });
    if (next) next.addEventListener('click', function () { go(index + 1, true); });
    dlg.querySelector('[data-om-zoom-close]').addEventListener('click', function () { dlg.close(); });
    dlg.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); go(index + 1, true); }
      else if (e.key === 'ArrowLeft') { e.preventDefault(); go(index - 1, true); }
    });
    window.addEventListener('resize', function () { if (dlg.open) go(index, false); }, { passive: true });

    /* Computador: clic en la foto = acercar al punto tocado; mover el mouse recorre la foto */
    track.addEventListener('click', function (e) {
      if (!hoverMq.matches) return;
      var img = e.target.closest('.om-zoom__img');
      if (!img) return;
      var slide = img.closest('.om-zoom__slide');
      var on = !slide.classList.contains('is-zoomed');
      unzoom();
      if (on) { slide.classList.add('is-zoomed'); pan(img, e); }
    });
    track.addEventListener('mousemove', function (e) {
      var img = e.target.closest('.is-zoomed .om-zoom__img');
      if (img) pan(img, e);
    });
    function pan(img, e) {
      var r = img.getBoundingClientRect();
      var x = Math.max(0, Math.min(100, ((e.clientX - r.left) / r.width) * 100));
      var y = Math.max(0, Math.min(100, ((e.clientY - r.top) / r.height) * 100));
      img.style.transformOrigin = x + '% ' + y + '%';
    }

    dlg.addEventListener('close', function () {
      document.documentElement.classList.remove('om-zoom-lock');
      unzoom();
      /* En celular la galería queda en la última foto vista */
      var id = slides[index] && slides[index].dataset.mediaId;
      if (mobileMq.matches && list && id) {
        var li = list.querySelector('[data-media-id="' + id + '"]');
        if (li) {
          var pl = parseFloat(getComputedStyle(list).paddingLeft) || 0;
          list.scrollTo({ left: li.getBoundingClientRect().left - list.getBoundingClientRect().left + list.scrollLeft - pl, behavior: 'auto' });
        }
      }
      if (trigger && document.contains(trigger)) trigger.focus({ preventScroll: true });
    });

    /* Tocar una foto de la galería abre el visor en esa foto */
    if (list) {
      list.addEventListener('click', function (e) {
        if (e.target.closest('a, button, video, iframe, model-viewer')) return;
        var li = e.target.closest('.om-pdp__media--image');
        if (!li) return;
        open(indexOfMedia(li.dataset.mediaId), list);
      });
    }
    /* Botón de lupa (teclado y lectores): abre en la foto visible */
    var btn = root.querySelector('[data-om-zoom-open]');
    if (btn) {
      btn.addEventListener('click', function () {
        var i = 0;
        if (list && mobileMq.matches) {
          var items = Array.prototype.slice.call(list.children);
          var lr = list.getBoundingClientRect();
          for (var k = 0; k < items.length; k++) {
            var r = items[k].getBoundingClientRect();
            if (r.left + r.width / 2 >= lr.left && r.left + r.width / 2 <= lr.right) { i = indexOfMedia(items[k].dataset.mediaId); break; }
          }
        } else if (list && list.firstElementChild) {
          i = indexOfMedia(list.firstElementChild.dataset.mediaId);
        }
        open(i, btn);
      });
    }
  }

  function init() { document.querySelectorAll('[data-om-zoom]').forEach(initZoom); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
